import React, { Component } from "react";
import PermissionHOC from "../../PermissionHOC";
import EditPencil from "../../../assets/edit-pencil.svg";
// import pdf from "../../../assets/pdf.svg";
import pdf from "../../../assets/pdf.jpeg";
// bootstrap;
import { UploadAttachmentsWithTitleComponent } from "../../../container/reusableComponent";
/// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// actions
import {
  getDownloadUserManualListAction,
  getUploadUserManualAction
} from "../../../actions/dowloadExcelActions";
import { capitalizeFirstAfterSpace } from "../../../helper";
import { LoaderPage } from "../../../component/Loader";
import { FILE_SIZE_LIMIT } from "../../../constant";
// contants
const MANUAL_UPLOADING_FORMATS = [".pdf"];

class DownloadManual extends Component {
  state = {
    groupCategory: "",
    check: false
  };

  componentDidMount() {
    const {
      props: { getDownloadUserManualListAction }
    } = this;
    getDownloadUserManualListAction();
  }

  // select categories
  onSelectCategory = e => {
    const { value } = e.target;
    this.setState({
      groupCategory: value
    });
  };

  onClick = groupCategory => {
    const { check } = this.state;
    this.setState({
      check: true,
      groupCategory: groupCategory
    });
  };

  // submit of attachment
  onSuccessUploadOfAttachmets = async (data = {}) => {
    try {
      const { id } = data;
      const {
        state: { groupCategory },
        props: { getUploadUserManualAction }
      } = this;
      await getUploadUserManualAction(undefined, {
        file: data.id,
        groupCategory: groupCategory
      });
      this.setState({ toggleAttachementDisplay: false, groupCategory: "" });
    } catch (error) {
      console.error(error.message);
    }
  };

  onCloseModal = () => {
    this.setState({ check: false });
  };

  render() {
    const {
      props: {
        permission,
        categoryList,
        userManual: { isLoading, userManualList }
      },
      state: { groupCategory, toggleAttachementDisplay, check },
      onToggleAttachment,
      onSelectCategory,
      onSuccessUploadOfAttachmets
    } = this;

    return (
      <div className="download_reports_container user_manual">
        <LoaderPage loading={this.props.userManual.isLoading} />
        {/* Upload Pop up */}
        {check ? (
          <UploadAttachmentsWithTitleComponent
            displayModal={check}
            onCloseModal={this.onCloseModal}
            fileFormats={MANUAL_UPLOADING_FORMATS}
            onSubmit={onSuccessUploadOfAttachmets}
            isFromManualDownload={true}
            fileSizeLimit={FILE_SIZE_LIMIT.MIS_USER_MANUAL}
          />
        ) : null}

        <h3 className="header user-manual-title" style={{ marginTop: "21px" }}>
          User Manual
        </h3>
        {userManualList.map(value => {
          const groupCategoryName =
            value.groupCategory.replace("_", " ") || "Downloading";
          return (
            <div
              key={value.groupCategory}
              className="download_reports user-reports-manual"
            >
              <span>
                {groupCategoryName === "PP" || groupCategoryName === "PMG"
                  ? groupCategoryName
                  : groupCategoryName === "STATE PMG"
                  ? "State PMG"
                  : capitalizeFirstAfterSpace(groupCategoryName)}
              </span>
              <div className="d-flex">
                <div className="edit-reports mr-3 d-flex align-center justify-content-center">
                  <img
                    onClick={() => this.onClick(value.groupCategory)}
                    className="edit-pencil"
                    src={EditPencil}
                  />
                </div>
                <div className="edit-reports pdf-border d-flex align-center justify-content-center">
                  <a
                    rel="noopener noreferrer"
                    className="download_icon"
                    target="_blank"
                    href={value.url}
                    download
                  >
                    <img
                      style={{ width: "2rem" }}
                      src={pdf}
                      alt="Download PDF"
                    />
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    categoryList: state.userManualReducer.categoryList,
    userManual: state.donwloadExcelReducer.userManual
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadUserManualListAction,
      getUploadUserManualAction
    },
    dispatch
  );
}

const DownloadManualComponent = PermissionHOC(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DownloadManual)
);
export { DownloadManualComponent };
